import { trigger, transition, style, query, animate } from '@angular/animations';
export const routerAnimations = trigger('routeAnimations', []);
